import { IValidationRule } from "@/types"

const fairValueFactorsRules: { [s: string]: IValidationRule } = {
    monthlySDC: {
        required: true,
        type: "decimal",
        gt: 0
    },
    monthlyStandard: {
        required: true,
        type: "integer",
        gt: 0,
        max: 2147483647,
    },
    depreciationRate: {
        required: true,
        type: "decimal",
        min: 0.01,
        max: 99.99,
    },
    rentalFeesPercentage: {
        required: true,
        type: "decimal",
        min: 0.01,
        max: 99.99,
    }
}

export default fairValueFactorsRules
